var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFiinGateEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000068651855751826687400000012999466767323806366_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 396.1 96.4",
    style: {
      enableBackground: "new 0 0 396.1 96.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#034EA2;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#034EA2;}\n\t.st2{fill:#50A4DB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,76.7h1.9L126,88h-1.8l-1-3.1h-4.3l-1,3.1h-1.8L120,76.7L120,76.7z M119.3,83.5h3.4l-1.7-4.9l0,0 L119.3,83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.3,76.7h4.2c2.2,0,3.7,1.5,3.7,3.7l0,0c0,2.2-1.5,3.7-3.7,3.7h-2.4v3.8h-1.8V76.7L133.3,76.7z  M135.1,78.2v4.5h2c1.5,0,2.4-0.8,2.4-2.2l0,0c0-1.4-0.9-2.2-2.4-2.2h-2V78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.3,76.7h4.4c2.3,0,3.8,1.3,3.8,3.4l0,0c0,1.5-0.8,2.8-2.2,3.2l2.5,4.6h-2l-2.3-4.3h-2.4v4.3h-1.8V76.7 L144.3,76.7z M148.5,82.2c1.4,0,2.1-0.7,2.1-2l0,0c0-1.2-0.8-2-2.2-2H146v4H148.5L148.5,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.2,82.3L155.2,82.3c0-3.6,2-5.8,5.3-5.8s5.3,2.2,5.3,5.8l0,0c0,3.6-2,5.8-5.3,5.8S155.2,85.9,155.2,82.3 z M163.9,82.3L163.9,82.3c0-2.6-1.4-4.3-3.5-4.3s-3.5,1.6-3.5,4.3l0,0c0,2.6,1.4,4.3,3.5,4.3S163.9,84.9,163.9,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.8,76.7h4c3.3,0,5.3,2.1,5.3,5.6l0,0c0,3.6-2,5.7-5.3,5.7h-4V76.7L168.8,76.7z M172.6,86.4 c2.4,0,3.7-1.5,3.7-4.1l0,0c0-2.7-1.3-4.1-3.7-4.1h-2.1v8.2H172.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.2,84v-7.3h1.8v7.2c0,1.6,1,2.7,2.8,2.7c1.8,0,2.8-1.1,2.8-2.7v-7.2h1.7V84c0,2.5-1.7,4.2-4.6,4.2 S181.2,86.5,181.2,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.5,82.3L193.5,82.3c0-3.6,2-5.8,5.2-5.8c2.5,0,4.4,1.5,4.7,3.8v0.1h-1.7l-0.1-0.2 c-0.4-1.3-1.4-2.1-2.9-2.1c-2.1,0-3.4,1.7-3.4,4.3l0,0c0,2.6,1.4,4.3,3.4,4.3c1.5,0,2.5-0.8,3-2.2v-0.1h1.7v0.1 c-0.4,2.2-2.2,3.8-4.7,3.8C195.5,88.1,193.5,85.9,193.5,82.3L193.5,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.7,78.2h-3.4v-1.5h8.6v1.5h-3.4V88h-1.8C208.7,87.9,208.7,78.2,208.7,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.1,82.3L221.1,82.3c0-3.6,2-5.8,5.3-5.8c3.3,0,5.3,2.2,5.3,5.8l0,0c0,3.6-2,5.8-5.3,5.8 C223.1,88.1,221.1,85.9,221.1,82.3z M229.8,82.3L229.8,82.3c0-2.6-1.4-4.3-3.5-4.3c-2.1,0-3.5,1.6-3.5,4.3l0,0 c0,2.6,1.4,4.3,3.5,4.3C228.4,86.6,229.8,84.9,229.8,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.7,76.7h7v1.5h-5.3v3.6h4.8v1.5h-4.8V88h-1.8L234.7,76.7L234.7,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.5,76.7h7v1.5h-5.3v3.6h4.8v1.5h-4.8V88h-1.8L249.5,76.7L249.5,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,76.7h1.8V88h-1.8V76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.7,76.7h1.8V88h-1.8V76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270,76.7h1.6l5.8,8.3l0,0v-8.3h1.7V88h-1.6l-5.8-8.3l0,0V88H270V76.7L270,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.3,82.3L282.3,82.3c0-3.6,2-5.8,5.2-5.8c2.6,0,4.3,1.5,4.8,3.6v0.1h-1.8v-0.1c-0.5-1.3-1.5-2.1-3-2.1 c-2.2,0-3.5,1.6-3.5,4.2l0,0c0,2.7,1.3,4.3,3.5,4.3c1.8,0,3.1-1.2,3.1-2.9v-0.2h-3V82h4.7v1.2c0,3.1-1.8,4.9-4.9,4.9 C284.4,88.1,282.3,85.9,282.3,82.3L282.3,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.5,76.7h4.4c2.3,0,3.8,1.3,3.8,3.4l0,0c0,1.5-0.8,2.8-2.2,3.2l2.5,4.6h-2l-2.3-4.3h-2.4v4.3h-1.8V76.7 L295.5,76.7z M299.7,82.2c1.4,0,2.1-0.7,2.1-2l0,0c0-1.2-0.8-2-2.2-2h-2.4v4H299.7L299.7,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.4,82.3L306.4,82.3c0-3.6,2-5.8,5.3-5.8s5.3,2.2,5.3,5.8l0,0c0,3.6-2,5.8-5.3,5.8S306.4,85.9,306.4,82.3 z M315.2,82.3L315.2,82.3c0-2.6-1.4-4.3-3.5-4.3s-3.5,1.6-3.5,4.3l0,0c0,2.6,1.4,4.3,3.5,4.3S315.2,84.9,315.2,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.1,84v-7.3h1.8v7.2c0,1.6,1,2.7,2.8,2.7c1.8,0,2.8-1.1,2.8-2.7v-7.2h1.7V84c0,2.5-1.7,4.2-4.5,4.2 S320.1,86.5,320.1,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.7,76.7h4.2c2.2,0,3.7,1.5,3.7,3.7l0,0c0,2.2-1.5,3.7-3.7,3.7h-2.5v3.8h-1.8L332.7,76.7L332.7,76.7z  M334.4,78.2v4.5h2c1.5,0,2.4-0.8,2.4-2.2l0,0c0-1.4-0.9-2.2-2.4-2.2h-2V78.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,39.4c3.8,6.5,12.7,4.7,19.1,4c-0.6,1.2-1.3,2.4-2,3.5c-1,1.7-1.9,1.4-3.7,1.5c-3,0.3-6.1,0.5-9.1,0 c-2.3-0.3-5-1.1-6.2-3.2C25.5,43.2,26.5,40.5,28.6,39.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.7,36.5c0,0-6.6,0.7-11.2,0.7s-7-2.4-7-5.6s2.9-6.4,7.5-6.4c6.1,0,14.4,4.7,14.4,4.7L51.7,36.5L51.7,36.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.4,48.1c0,0,8.7-0.8,11.6-0.8s9.7,1.5,9.7,7.2c0,6.7-12.2,11.1-12.2,11.1l6.8,1.8c0,0,9.9-5.6,9.9-13.3 s-7-11.4-13.5-11.4s-9.6,0.7-9.6,0.7L47.4,48.1L47.4,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.3,55.1l-3.1,5.5c0,0,5.8,1.2,13.1,3.9c0,0,8.7-3.5,8.7-7.7c0-2.2-2.2-2.9-3.8-2.9S43.3,55.1,43.3,55.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.9,68.8c-7.1-2.5-20.2-5.1-20.2,0.4S37.9,72.6,43.9,68.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.1,6.6C25.2,6.6,6.7,25.1,6.7,48s18.6,41.5,41.5,41.5S89.6,70.9,89.6,48S71,6.6,48.1,6.6 M56.9,73.1 l-9.7-3.2c0,0-27,12.3-27-2.6c0-10.2,18-7,18-7l2.4-4.9c0,0-19.3,2.9-19.3-8.9c0-7.3,7.1-8.9,7.1-8.9c0-9.5,14.2-19.1,14.2-19.1 l16.3,5.4l2.5-4.4l1.9,1L54,36.4c0,0,25-3,25,12.4C78.9,66,56.9,73.1,56.9,73.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.2,96.4C21.6,96.4,0,74.8,0,48.2S21.6,0,48.2,0s48.2,21.6,48.2,48.2S74.8,96.4,48.2,96.4 M48.2,3.7 c-24.6,0-44.5,20-44.5,44.5s20,44.5,44.5,44.5s44.5-20,44.5-44.5S72.8,3.7,48.2,3.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.9,9.3h33.4v8.8h-22.7v13.7h20.7v8.4h-20.7v20.1h-10.7C115.9,60.3,115.9,9.3,115.9,9.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "155.3,25.1 165.6,22.4 165.6,60.3 155.3,60.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "171.7,25.1 182,22.4 182,60.3 171.7,60.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.3,34.7L228.3,34.7c0-16.3,9.4-26.2,24.3-26.2c12.3,0,20.6,7.1,22.3,16.7l0.1,0.5h-10.7l-0.1-0.4 c-1.7-4.9-5.8-7.8-11.5-7.8c-8.4,0-13.5,6.2-13.5,17l0,0c0,11.1,5.4,17.6,13.9,17.6c7,0,11.7-4.1,12-10.4V41h-11.7v-8h22v5.9 c0,13.9-8.4,22.3-22.6,22.3C237.7,61.2,228.3,51.3,228.3,34.7L228.3,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.2,35.9v24.4h-10.3V38c0-5-2.3-7.8-7-7.8s-7.6,3.4-7.6,8.3v21.8H188V25.1l10.3-2.7v7.4h0.2 c1.9-4.4,5.8-8.2,11.6-8.2C218.4,21.7,223.2,27,223.2,35.9L223.2,35.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "182,18.1 171.7,20.8 171.7,12 182,9.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "165.6,18.1 155.3,20.8 155.3,12 165.6,9.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.2,9.3c3.7,0,7,2.6,7,6.6s-3.3,6.6-7,6.6s-7-2.6-7-6.6S385.5,9.3,389.2,9.3z M389.2,21.1 c2.8,0,5.1-2.2,5.1-5.2s-2.3-5.2-5.1-5.2s-5.1,2.2-5.1,5.2S386.3,21.1,389.2,21.1z M389.4,12.2c1.9,0,3,0.6,3,2.2 c0,1.4-0.9,1.9-2,2l2,3.2h-1.6l-1.9-3.2H388v3.2h-1.5v-7.4C386.5,12.2,389.4,12.2,389.4,12.2z M389.3,15.3c0.9,0,1.5-0.1,1.5-1 c0-0.8-0.9-0.9-1.6-0.9H388v1.9H389.3L389.3,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.8,41.3L343.8,41.3c0-12.1,7.1-19.8,18.2-19.8s18,7.5,18,19v3.2h-26.1c0.1,6,3.4,9.6,8.6,9.6 c4.2,0,6.8-2.3,7.6-4.5l0.1-0.2h9.5l-0.1,0.4c-1.2,5.6-6.4,12-17.2,12C350.8,60.9,343.8,53.4,343.8,41.3L343.8,41.3z M354.1,37.2 h16.1c-0.6-5.2-3.7-8-8-8S354.7,32.1,354.1,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.6,49.7L280.6,49.7c0-7,5.3-11,14.7-11.6l9.4-0.6v-2.3c0-3.4-2.2-5.4-6.2-5.4s-6.2,1.8-6.7,4.2l-0.1,0.3 h-9.4v-0.4c0.6-7,6.6-12,16.6-12S315,27,315,34.6v26h-10.3v-5.7h-0.2c-2.1,3.9-6.2,6.2-11.2,6.2C285.8,61.2,280.7,56.4,280.6,49.7 L280.6,49.7z M296.7,53.7c4.6,0,8-3,8-6.9V44l-7.8,0.5c-4,0.2-6.1,1.9-6.1,4.6v0.1C290.8,52,293.1,53.7,296.7,53.7L296.7,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.2,50V30.5H318v-7.8h5.3v-9.2h10.4v9.2h6.9v7.8h-6.9v18.4c0,3.5,1.6,4.7,4.7,4.7c0.9,0,1.6-0.1,2.2-0.2 V61c-1.2,0.2-2.8,0.4-5,0.4C327.2,61.3,323.2,58.1,323.2,50L323.2,50z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFiinGateEn);
export default __webpack_public_path__ + "static/media/logoFiinGateEN.c8728cc89614f15bff1b54d347df62d5.svg";
export { ForwardRef as ReactComponent };